/**
 * True when the page was opened through a share link AND nobody is signed in.
 *
 * Share mode alone is not enough to block following. A signed-in visitor still
 * sends their own bearer token (see TRPCLoader), so the protected follow
 * endpoints accept them. Gating on share mode alone disabled the button for
 * signed-in users and told them to sign up.
 */
export function isAnonymousShareView(isPublicMode: boolean, userToken: string | null | undefined): boolean {
  return isPublicMode && (userToken === null || userToken === undefined || userToken === '');
}
